import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useNavigate } from 'react-router-dom';
import { LuCrown } from "react-icons/lu";

const MySwal = withReactContent(Swal);

const Settings = () => {
    const navigate = useNavigate();
    const echoUser = localStorage.getItem("echo_user");
    const [name, setName] = useState('');
    const [bio, setBio] = useState('');
    const [avatar, setAvatar] = useState('');
    const [preview, setPreview] = useState('');
    const [vip, setVip] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await fetch("https://api.fantasyworldtrpg.cz/echo/profile.php", {
                    method: "POST",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: echoUser })
                });
                const data = await res.json();
                if (data.status === 'success') {
                    setName(data.user.display_name);
                    setBio(data.user.bio || '');
                    setAvatar(data.user.avatar || '');
                    setPreview(data.user.avatar || '');
                    setVip(data.user.vip || 0);
                }
            } catch (err) {
                console.error(err);
            }
        };

        fetchData();
    }, [echoUser]);

    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            setPreview(URL.createObjectURL(file));
            const base64 = await toBase64(file);
            const url = await uploadToImgBB(base64);
            if (url) {
                setAvatar(url);
            } else {
                await MySwal.fire("Chyba", "Nepodařilo se nahrát fotku.", "error");
            }
        }
    };

    const toBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });

    const uploadToImgBB = async (base64Data) => {
        const form = new FormData();
        form.append('key', 'f2864012d8fdd791aceb36f194a58cb2');
        form.append('image', base64Data.split(',')[1]);

        try {
            const res = await fetch('https://api.imgbb.com/1/upload', {
                method: 'POST',
                body: form
            });
            const json = await res.json();
            return json.success ? json.data.url : null;
        } catch (err) {
            console.error("Chyba při uploadu:", err);
            return null;
        }
    };

    const handleSave = async () => {
        try {
            const res = await fetch("https://api.fantasyworldtrpg.cz/echo/update_profile.php", {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: echoUser,
                    name,
                    bio,
                    avatar
                })
            });

            const data = await res.json();
            if (data.status === "success") {
                await MySwal.fire("Hotovo!", "Profil byl aktualizován.", "success");
            } else {
                throw new Error();
            }
        } catch (err) {
            console.error(err);
            await MySwal.fire("Chyba", "Nepodařilo se uložit změny.", "error");
        }
    };

    return (
        <div className="container py-5 my-5">
            <h2 className="mb-4">⚙️ Nastavení profilu</h2>

            <div className="mb-3">
                <label className="form-label">Profilová fotka</label><br/>
                {preview && (
                    <img src={preview} alt="Preview" style={{ width: 100, height: 100, borderRadius: '50%', objectFit: 'cover', marginBottom: 10 }} />
                )}
                <input type="file" className="form-control" onChange={handleImageChange} />
            </div>

            <div className="mb-3">
                <label className="form-label">Jméno</label>
                <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} />
            </div>

            <div className="mb-3">
                <label className="form-label">Bio</label>
                <textarea className="form-control" rows="3" value={bio} onChange={(e) => setBio(e.target.value)}></textarea>
            </div>

            <button className="btn btn-danger w-100" onClick={handleSave}>
                💾 Uložit změny
            </button>

            {(vip === "1" && (
                <button className="btn btn-danger mt-5" onClick={() => navigate("/vip")}>
                    <LuCrown/> Přejít na VIP nastavení
                </button>
            ))}
        </div>
    );
};

export default Settings;
